import { Box, Stack, Typography } from "@mui/material";
import type { Snapshot } from "../types";
import { mw } from "../utils/format";
import DashboardCard from "./DashboardCard";
import { PendingValue } from "./PendingValue";

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {label}
      </Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 600 }}>
        {value ?? <PendingValue />}
      </Typography>
    </Box>
  );
}

export default function PlantSnapshotCard({
  snapshot,
}: {
  snapshot: Snapshot;
}) {
  return (
    <DashboardCard title="Plant Snapshot">
      <Stack spacing={1.25}>
        <Row label="Technology" value={snapshot.technology} />
        <Row
          label="Installed capacity"
          value={
            snapshot.capacity_mw === null
              ? null
              : `${mw(snapshot.capacity_mw)} MW`
          }
        />
        <Row label="Configuration" value={snapshot.configuration} />
        <Row
          label="Remaining life"
          value={
            snapshot.remaining_life_years === null
              ? null
              : `${snapshot.remaining_life_years} years`
          }
        />
      </Stack>
    </DashboardCard>
  );
}
